import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

import { HOME } from "../constants/routes";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Button
          onClick={() => {
            navigate(HOME);
          }}
          type="primary"
        >
          Back Home
        </Button>
      }
    />
  );
};

export default NotFound;
